import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'section-heading',
  templateUrl: './section-heading.component.html',
  styleUrls: ['./section-heading.component.scss'],
  standalone: false,
})
export class SectionHeadingComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
